import { useUserStore } from '@/stores/user.js'
import { storeToRefs } from 'pinia'

// Middleware to redirect users based on their verification status and organization
// If user is verified they should not be redirected to confirm email page
export default async function emailVerified({ next }) {
  try {
    const { currentOrganization, user } = useUserStore()
    const verified = user?.email_verified
    const currentOrganizationId = currentOrganization?.id

    if (verified === 1 && currentOrganizationId > 0) {
      return next({ name: 'dashboard' })
    }
    return next()
  } catch (e) {
    console.error('Error in emailVerified middleware:', e)
    return next({ name: 'login' })
  }
}
